export class ClientS3Service {
  /**
   * Uploads a file to AWS S3 using a presigned URL
   * @param {{ presignedUrl: string, filename: string }} presignedUrlData The REST response containing the presigned URL
   * @param {File} selectedFile The file to upload
   * @returns {Promise<{presignedUrl: string, filename: string} | null>} Resolving to the presigned URL and filename if successful, null otherwise
   */
  static async uploadFile(presignedUrlData, selectedFile) {
    try {
      const { presignedUrl, filename } = presignedUrlData || {};

      if (!presignedUrl || !filename) {
        console.error('Missing presigned URL or filename');
        return null;
      }

      const response = await fetch(presignedUrl, {
        method: 'PUT',
        body: selectedFile,
        headers: {
          'Content-Type': selectedFile.type || 'application/octet-stream'
        }
      });

      if (response.ok) {
        console.log('Upload successful!');
        return { presignedUrl, filename };
      }

      const errorBody = await response.text();
      console.error('Upload failed with status:', response.status, errorBody);
      return null;
    } catch (error) {
      console.error('Error uploading to S3:', error);
      return null;
    }
  }
}
